export default __webpack_public_path__ + "static/media/new-campaign-2x.967db583.jpg";